<p-dialog header="Associated Users" [(visible)]="displayAssociatedUsersModal" [modal]="true" [responsive]="true"
    [style]="{width: '60em'}" (onHide)="closeAssociatedUserModal()">
        <div class="card">
              <p-table #associatedUserTable [value]="associatedUsers" [paginator]="true" [rows]="10" [responsive]="true">
                  <ng-template pTemplate="header">
                      <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Profile Image</th>
                          <th>Action</th>
                          <th style="width: 2rem;">
                            <span class="btnBars" (click)="addUserModal()">
                                <i class="pi pi-plus"></i>
                            </span>
                          </th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-user>
                      <tr>
                          <td>{{ user.name }}</td>
                          <td>{{ user.emailAddress }}</td>
                          <td class="user-display"> 
                            <img [src]="user.profileImageUrl ? user.profileImageUrl : defaultProfileImage" />
                          </td>
                          <td class="action">
                            <span
                                class="btnBars p-mr-0"
                                (click)="deleteUser(user)" 
                                pTooltip="Delete" 
                                tooltipPosition="top">
                                <i class="pi pi-trash"></i></span>
                          </td>
                          <td></td>
                          
                      </tr>
                  </ng-template>
              </p-table>
        </div>
    <p-footer>
        <button type="button" pButton (click)="closeAssociatedUserModal()" label="Close"
        class="p-button-secondary"></button>
    </p-footer>
</p-dialog>


<!-- Add User Modal -->
<p-dialog header="Add User" [modal]="true" [(visible)]="displayAddUserModal" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="closeAddUserModal()">
    <form [formGroup]="addUserForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label for="type">Add a user <span style="color: red;">*</span></label>
                    <p-dropdown [options]="users" optionLabel="name" [filter]="true" filterBy="name" placeholder="Select a user" appendTo="body"
                        formControlName="newUser"></p-dropdown>
                    <small *ngIf="newUser.invalid && (newUser.touched || newUser.dirty)" class="p-invalid">
                        <span *ngIf="newUser.errors?.['required']" class="p-invalid">
                            user is required
                        </span>
                    </small>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeAddUserModal()" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="AddNewUser()" label="Save" [disabled]="addUserForm.invalid"></button>
    </ng-template>
</p-dialog>

<!-- Transfer Job Type Modal -->
<p-dialog header="Transfer Job Type" [modal]="true" [(visible)]="displayTransferJobTypeModal" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="closeTransferJobTypeModal()">
    <form [formGroup]="jobTypeTransferForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <p>Associated User: <b>{{selectedUser?.name}}</b></p>
                </div>
                <div class="p-col-12">
                    <p>Deleted from Job Type: <b>{{jobTypeTransferData?.name}}</b></p>
                </div>
                <div class="p-col-12">
                    <label for="type">Move user to Job Type <span style="color: red;">*</span></label>
                    <p-dropdown 
                            [options]="filteredJobTypes" 
                            optionLabel="name" 
                            appendTo="body"
                            placeholder="Select a job type"
                            formControlName="jobType"></p-dropdown>
                    <small *ngIf="jobType.invalid && (jobType.touched || jobType.dirty)" class="p-invalid">
                        <span *ngIf="jobType.errors?.['required']" class="p-invalid">
                            Job Type is required
                        </span>
                    </small>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeTransferJobTypeModal()" label="Cancel"
            class="p-button-secondary"></button>
        <button pButton (click)="transferAndDeleteJobType()" [disabled]="jobTypeTransferForm.invalid" label="Transfer and Delete"></button>
    </ng-template>
</p-dialog>


<!-- Transfer Profile Modal -->
<p-dialog header="Transfer Profile" [modal]="true" [(visible)]="displayTransferProfile" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="closeTransferProfileModal()">
    <form [formGroup]="profileTransferForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <p>Associated User: <b>{{selectedUser?.name}}</b></p>
                </div>
                <div class="p-col-12">
                    <p>Deleted from profile: <b>{{profileTransferData?.name}}</b></p>
                </div>
                <div class="p-col-12">
                    <label for="type">Move user to Profile <span style="color: red;">*</span></label>
                    <p-dropdown 
                            [options]="filteredProfiles" 
                            optionLabel="name" 
                            appendTo="body"
                            placeholder="Select a profile"
                            formControlName="profile"></p-dropdown>
                    <small *ngIf="profile.invalid && (profile.touched || profile.dirty)" class="p-invalid">
                        <span *ngIf="profile.errors?.['required']" class="p-invalid">
                            Profile is required
                        </span>
                    </small>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeTransferProfileModal()" label="Cancel"
            class="p-button-secondary"></button>
        <button pButton (click)="transferAndDeleteProfile()" [disabled]="profileTransferForm.invalid" label="Transfer and Delete"></button>
    </ng-template>
</p-dialog>

<!-- Transfer Role Hierarchy Modal -->
<p-dialog header="Transfer Role Hierarchy" [modal]="true" [(visible)]="displayRoleHierarchyTransferModal" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="closeRoleHierarchyTransferModal()">
    <form [formGroup]="roleHierarchyTransferForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <p>Associated User: <b>{{selectedUser?.name}}</b></p>
                </div>
                <div class="p-col-12">
                    <p>Deleted from Role Hierarchy: <b>{{selectedRoleHierarchyName}}</b></p>
                </div>
                <div class="p-col-12">
                    <label for="type">Move user to Role <span style="color: red;">*</span></label>
                    <liono-treeSelect 
                        [options]="filteredRoleHierarchy"
                        placeholder="Select new role"
                        appendTo="body" 
                        formControlName="role"></liono-treeSelect>
                        <small *ngIf="role.invalid && (role.touched || role.dirty)" class="p-invalid">
                            <span *ngIf="role.errors?.['required']" class="p-invalid">
                              New role is required
                            </span>
                        </small>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeRoleHierarchyTransferModal()" label="Cancel"
            class="p-button-secondary"></button>
        <button pButton (click)="transferAndDeleteRoleHierarchy()" [disabled]="roleHierarchyTransferForm.invalid" label="Transfer and Delete"></button>
    </ng-template>
</p-dialog>